import { getApiBaseUrl } from '../../config/runtimeConfig';
import { sessionFetch } from '../../services/session';
async function request(path = '', options = {}) {
 let response;
 try { response = await sessionFetch(`${getApiBaseUrl()}/packaging-types${path}`, { credentials: 'include', ...options, headers: { Accept: 'application/json', ...options.headers }, signal: AbortSignal.timeout(20000) }); }
 catch (error) { throw new Error('Unable to connect. Please try again.'); }
 const data = await response.json().catch(() => null);
 if (!response.ok) throw Object.assign(new Error(data?.message || 'Unable to complete the packaging type request.'), { status: response.status });
 return data;
}
let pending;
export function getPackagingTypes() {
 if (!pending) pending = request().then(data => data.packaging_types || []).finally(() => { pending = null; });
 return pending;
}
export async function getPackagingType(id) { return (await request(`/${id}`)).packaging_type; }
const payload = (method, data) => ({ method, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) });
export async function createPackagingType(data) { return (await request('', payload('POST', data))).packaging_type; }
export async function updatePackagingType(id, data) { return (await request(`/${id}`, payload('PUT', data))).packaging_type; }
export function deletePackagingType(id) { return request(`/${id}`, { method: 'DELETE' }); }
